import { useSettingFaireDirectCreditForVisitorPhase2 } from "@faire/retailer-visitor-shared/settings/useSettingFaireDirectCreditForVisitor";

export const useFaireDirectInfoForXP = <T>(control: T, treatment: T): T => {
  const isFaireDirectCreditForVisitorPhase2 =
    useSettingFaireDirectCreditForVisitorPhase2();

  return isFaireDirectCreditForVisitorPhase2 ? treatment : control;
};
